import { useEffect } from "react";
import { useLocation, Link, NavLink } from "react-router-dom";

const AgentSidebar = () => {
    const location = useLocation();
    const currentPath = location.pathname;


    const isPathActive = (path) => currentPath === path;

    const isBookingDetailsActive = [
        "/Agent/Booking",
        "/Agent/Bookinglist"
    ].some(path => currentPath.startsWith(path));



    useEffect(() => {
        const wrapper = document.querySelector('.wrapper');
        if (wrapper && !wrapper.classList.contains('sidebar_minimize')) {
                wrapper.classList.add('sidebar_minimize');
            }
        const toggleSidebarBtn = document.querySelector('.toggle-sidebar');
        const sidenavTogglerBtn = document.querySelector('.sidenav-toggler');
        const sidebarElement = document.querySelector('.sidebar');

        const toggleSidebar = () => {
            if (wrapper) {
                wrapper.classList.toggle('sidebar_minimize');
            }
        };

        const handleMouseEnter = () => {
            if (wrapper && wrapper.classList.contains('sidebar_minimize')) {
                wrapper.classList.add('sidebar_minimize_hover');
            }
        };

        const handleMouseLeave = () => {
            if (wrapper) {
                wrapper.classList.remove('sidebar_minimize_hover');
            }
        };

        // Add click event listeners
        toggleSidebarBtn?.addEventListener('click', toggleSidebar);
        sidenavTogglerBtn?.addEventListener('click', toggleSidebar);

        // Hover effect
        sidebarElement?.addEventListener('mouseenter', handleMouseEnter);
        sidebarElement?.addEventListener('mouseleave', handleMouseLeave);

        // Cleanup on unmount
        return () => {
            toggleSidebarBtn?.removeEventListener('click', toggleSidebar);
            sidenavTogglerBtn?.removeEventListener('click', toggleSidebar);
            sidebarElement?.removeEventListener('mouseenter', handleMouseEnter);
            sidebarElement?.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, []);


    return (
        <div className="sidebar" data-background-color="dark">
            <div className="sidebar-logo">
                <div className="logo-header" data-background-color="dark">
                    <Link to="/" className="logo">
                        <img
                            src="../assets/img/BookOnNile Logo.svg"
                            alt="navbar brand"
                            className="navbar-brand"
                            style={{ backgroundColor: "#fff", padding: "4px", width: "60px", margin: "0 auto", height: "49px" }}
                        />
                    </Link>
                    <div className="nav-toggle">
                        <button className="btn btn-toggle toggle-sidebar"><i className="gg-menu-right" /></button>
                        <button className="btn btn-toggle sidenav-toggler"><i className="gg-menu-left" /></button>
                    </div>
                    <button className="topbar-toggler more"><i className="gg-more-vertical-alt" /></button>
                </div>
            </div>

            <div className="sidebar-wrapper scrollbar-inner">
                <div className="sidebar-content">
                    <ul className="nav nav-secondary">
                        <li className={isPathActive("/") ? "nav-item active" : "nav-item"}>
                            <NavLink to="/" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                <i className="fas fa-home" /><p>Home</p>
                            </NavLink>
                        </li>

                        <li className={isPathActive("/dashboard") ? "nav-item active" : "nav-item"}>
                            <NavLink to="/Agent/Dashboard" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                <i className="fas fa-tachometer-alt" /><p>Dashboard</p>
                            </NavLink>
                        </li>

                        {/* <li className="nav-section">
                            <span className="sidebar-mini-icon"><i className="fa fa-ellipsis-h" /></span>
                            <h4 className="text-section">Components</h4>
                        </li> */}

                        {/* Booking Details */}
                        <li className={`nav-item ${isBookingDetailsActive ? "active submenu" : ""}`}>
                            <a href="/" onClick={(e) => e.preventDefault()} data-bs-toggle="collapse" data-bs-target="#bookingDetails" aria-expanded={isBookingDetailsActive}>
                                <i className="fas fa-calendar-check" /><p>Booking Details</p><span className="caret" />
                            </a>
                            <div className={`collapse ${isBookingDetailsActive ? "show" : ""}`} id="bookingDetails">
                                <ul className="nav nav-collapse">
                                    <li className={isPathActive("/Agent/Booking") ? "active" : ""}>
                                        <NavLink to="/Agent/Booking" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Agent Booking</span>
                                        </NavLink>
                                    </li>
                                    <li className={isPathActive("/Agent/Bookinglist") ? "active" : ""}>
                                        <NavLink to="/Agent/Bookinglist" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}>
                                            <span className="sub-item">Agent Booking List</span>
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </li>

                    </ul>
                </div>
            </div>
        </div>
    );
};

export default AgentSidebar;

